export default {
  user: {
    authenticated: false,
    userObj: null,
    username: null,
    newUser: null,
    userGroups: []
  }
}



// WEBPACK FOOTER //
// ./src/store/state.js